import { useEffect } from 'react';
import Aos from "aos";
import { scroller } from 'react-scroll';

const NoTestimonials = () => {
	useEffect(() => {
		Aos.init({ duration: 1000 });
	}, []);
	return (
		<div className="flex flex-col justify-center w-full relative md:min-h-[80vh] min-h-[40vh] mb-36 md:mb-0">
			{/* Background animated circles */}
			<div className="absolute inset-0 pointer-events-none" data-aos="fade" data-aos-offset="120">
				<div className="absolute w-32 h-32 border-2 border-[#00fffc] rounded-full opacity-20 animate-ping top-1/4 left-1/4 [animation-duration:2s] [animation-delay:0s]"></div>
				<div className="absolute w-24 h-24 border-2 border-[#00fffc] rounded-full opacity-30 animate-ping top-2/3 right-1/3 [animation-duration:2s] [animation-delay:0.2s]"></div>
				<div className="absolute w-16 h-16 border-2 border-[#00fffc] rounded-full opacity-40 animate-ping top-1/4 right-1/3 [animation-duration:2s] [animation-delay:0.1s]"></div>
			</div>

			{/* Main content */}
			<div className="relative text-center space-y-4 max-w-md mx-6 md:mx-auto" data-aos="zoom-in-up" data-aos-offset="120">
				{/* Code-style message */}
				<div className="bg-gray-900 border border-[#00fffc]/30 rounded-lg p-3 mt-4">
					<div className="flex justify-between items-center mb-2 border-b border-[#00fffc]/50 pb-2">
						<span className="text-[#00fffc] font-mono text-sm">testimonials.js</span>
						<div className="flex space-x-1">
							<div className="w-3 h-3 bg-red-500 rounded-full"></div>
							<div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
							<div className="w-3 h-3 bg-green-500 rounded-full"></div>
						</div>
					</div>
					<div className="text-left font-mono text-xs md:text-sm space-y-1">
						<p className="text-green-400">
							<span className="text-gray-500 select-none">1</span> <span className="text-purple-400">if</span> (<span className="text-blue-400">you</span>.<span className="text-yellow-400">loved</span>.<span className="text-[#00fffc]">thisPortfolio</span>) {'{'}
						</p>
						<p className="text-green-400">
							<span className="text-gray-500 select-none">2</span>   <span className="text-[#00fffc]">&nbsp;&nbsp;leaveFeedBack</span>();
						</p>
						<p className="text-green-400">
							<span className="text-gray-500 select-none">3</span> {'}'}
						</p>
					</div>

					{/* Execute button */}
					<div className="mt-4 pt-3 border-t border-[#00fffc]/50">
						<button
							onClick={() => scroller.scrollTo('contact', {
								duration: 500,
								delay: 0,
								smooth: true,
								offset: -10
							})}
							className="w-full bg-[#00fffc] text-gray-900 font-mono text-sm py-2 px-4 rounded hover:bg-[#00fffc]/90 transition-colors duration-200 flex items-center justify-center space-x-2 group"
						>
							<span>▶</span>
							<span>Execute Code()</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default NoTestimonials;